<!-- 地锁停车记录 -->
<template>
  <article class="ground-parking-record">
    <el-form
      :inline="true"
      class="panel panel-default panel-search"
    >
      <el-form-item label="车牌号">
        <el-input
          v-model="form.carNum"
          style="width:120px"
          :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="泊位号">
        <el-input
          v-model="form.parkingLotCode"
          style="width:120px"
          :clearable="true"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="search"
          v-keycode="'ENTER'"
        >查询</el-button>
      </el-form-item>
    </el-form>
    <v-table
      ref="table"
      :page="page"
      class="panel-main"
      :table-minheight="450"
    >
      <!-- <el-table-column
        prop="code"
        header-align="center"
        label="编号"
      >
        <template slot-scope="{row}">{{row.parkInfo.name}}</template>
      </el-table-column> -->
      <el-table-column
        prop="parkLotCode"
        header-align="center"
        label="泊位号"
      ></el-table-column>
      <el-table-column
        prop="carNum"
        header-align="center"
        label="车牌号"
        :formatter="formateCarNum"
      ></el-table-column>
      <el-table-column
        prop="entryOn"
        header-align="center"
        label="开始时间"
      ></el-table-column>
      <el-table-column
        prop="leaveOn"
        header-align="center"
        label="结束时间"
      ></el-table-column>

      <el-table-column
        prop="onlineActualPayed"
        label="停车费用"
        header-align="center"
      ></el-table-column>
      <el-table-column
        prop="statusValue"
        width="80"
        header-align="center"
        label="状态"
      >
      </el-table-column>
      <el-table-column
        width="80"
        label="操作"
        header-align="center"
        :fixed="'right'"
      >
        <template slot-scope="{row}">
          <el-button
            v-if="row.payId"
            type="text"
            title="支付记录"
            @click="viewPayDtl(row.payId)"
          >
            支付记录
          </el-button>
        </template>
      </el-table-column>
    </v-table>
  </article>
</template>
<script>
  export default {
    name: "groundParkingRecord",
    data() {
      return {
        form: {
          carNum: null
        },
        page: {
          query: {
            param: {}
          },
          getData: this.$api.groundPark.parkRecord.query
        }
      };
    },
    methods: {
      formateCarNum({ carNum }) {
        return carNum === null ? "--" : carNum;
      },
      search() {
        this.page.query.param = {
          parkingLotCode: this.form.parkingLotCode || null,
          carNum: this.form.carNum || null
        };
        this.$refs.table.load();
      },
      viewPayDtl(payId) {
        this.$api.groundPark.parkRecord.fetchPayDtl(payId).then(({ bizOrderNo }) => {
          this.$router.push({
            path: "/groundpark/f/payrecord",
            query: {
              bizOrderNo
            }
          });
        });
      },
      init() {
        this.search();
      }
    },
    mounted() {
      this.$on("init", this.init);
    }
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// park-record.vue?6fc105d0